import { businessApiRoute, post } from './Api';
import usePutApi from './usePutApi';
import type { ApiOptions } from './Types';

export default function (route: string, opts?: ApiOptions) {
    return usePutApi(businessApiRoute(route), opts);
}
